import { setStore } from "@/util/storage";

export default {
	// 登录
	login(state, userInfo = null) {
		if (userInfo && userInfo.token) {
			state.login = true
			setStore('orientUser', userInfo);
		} else {
			state.login = false
			setStore('orientUser', '');
		}
		state.userInfo = userInfo
	},
	// 退出登录
	logout(state) {
		state.login = false
		setStore('orientUser', '');
	},
	// 侧边栏导航收起与展开
	switch_sidebar(state) {
		state.showSidebar = !state.showSidebar
	},
	// 登录重定向
	loginRedirect(state, path) {
		state.loginRedirect = path
	}
}